import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

const useManageUuid = (storageKey = "app_uuid") => {
  const [uuid, setUuid] = useState(null);

  useEffect(() => {
    // Try to get existing UUID from localStorage
    const storedUuid = localStorage.getItem(storageKey);

    if (storedUuid) {
      setUuid(storedUuid);
    } else {
      // Generate new UUID if none exists
      const newUuid = uuidv4();
      localStorage.setItem(storageKey, newUuid);
      setUuid(newUuid);
    }
  }, [storageKey]);

  return uuid;
};

export default useManageUuid;
